import Vue from "vue";
import { ActionTree, MutationTree } from "vuex";
import { RootState } from "@/store/types";
import { ServerResult } from "@/core/http/server_result";
import moment from "moment";
import { saveAs } from "file-saver";
import { generateFormObject } from "@/core/tools/forms/generate_form_object";

interface MarginalityByProductReportState {
  loaded: boolean;
  loading: boolean;
  fatalError: boolean;

  filter: {
    with_container: any;
    targetDates: Date[];
  };

  data: any[];
  total: any;
}

const state: MarginalityByProductReportState = {
  loading: false,
  loaded: false,
  fatalError: false,

  filter: {
    with_container: null,
    targetDates: [new Date(), new Date()]
  },

  data: [],
  total: {}
};

function buildFilter(params: any) {
  const queryParams: any = {};

  if (params.targetDates) {
    queryParams.date_from = moment(params.targetDates[0]).format("YYYY-MM-DD");
    queryParams.date_to = moment(params.targetDates[1]).format("YYYY-MM-DD");
  }
  if (params.with_container == "true") {
    queryParams.with_container = "true";
  }
  if (params.product_types && params.product_types.length > 0) {
    queryParams.product_types = Array.isArray(params.product_types)
      ? params.product_types
      : [params.product_types];
  }

  return queryParams;
}

export const REPORT_DATA = "REPORT_DATA";

export const actions: ActionTree<MarginalityByProductReportState, RootState> = {
  loadData({ commit, state, dispatch }, params) {
    const vm = (this as any)._vm;

    return new Promise((resolve, reject) => {
      if (Object.values(params).length > 0) {
        commit("START_LOADING");

        vm.$db([
          vm
            .$q(REPORT_DATA)
            .raw("reports.margin_by_product")
            .action(buildFilter(params))
        ]).then((result: ServerResult) => {
          commit(
            "SET_REPORT_DATA",
            result.getOperation(REPORT_DATA).getContent()
          );
          commit("LOADED_SUCCESS");

          resolve();
        });
      } else {
        resolve();
      }
    });
  },

  exportDataAsXLSX({ rootState }, params) {
    const vm = (this as any)._vm;

    return new Promise((resolve, reject) => {
      vm.$db([
        vm
          .$q("EXPORT")
          .raw("reports.margin_by_product.export")
          .action({ ...buildFilter(params), format: "xlsx" })
      ]).then((result: ServerResult) => {
        const exportOpContent = result.getOperation("EXPORT").getContent();
        const fToken = exportOpContent.token;
        const aToken = (rootState as any).ubic.token;
        const fileUrl = `${process.env.VUE_APP_UBIC_SERVER_ADDRESS}/api/v1/exports/${fToken}?authorization=${aToken}`;
        saveAs(fileUrl, "export.xlsx");

        resolve();
      });
    });
  }
};

export const mutations: MutationTree<MarginalityByProductReportState> = {
  START_LOADING: state => {
    state.loaded = false;
    state.loading = true;
    state.fatalError = false;
  },
  LOADED_SUCCESS: state => {
    state.loaded = true;
    state.loading = false;
    state.fatalError = false;
  },
  LOADED_ERROR: state => {
    state.loaded = true;
    state.loaded = false;
    state.fatalError = true;
  },

  SET_REPORT_DATA(state, { documents, sums, schema }) {
    state.data = documents.map((doc: any) => {
      return generateFormObject(schema, doc);
    });
    state.total = sums;
    state.total.margin_percent =
      ((state.total.profit - state.total.prime_costs) / state.total.profit) *
      100;
  }
};

const getters = {};

export const STORE_KEY = "$_marginality_by_product_report";

export const store = {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
